module.exports = __webpack_public_path__ + "static/4iiii1-66058e9cfbc619a150fc6160636e347d.jpg";